import React, { useEffect, useState, useRef, useCallback, useMemo, forwardRef, useImperativeHandle } from 'react';
import { ArrowDownOutlined, CaretUpOutlined, LoadingOutlined } from '@ant-design/icons';
import { Affix } from 'antd';
import { useFunction } from '@laigu/store';
import { useLocation } from 'react-router-dom';

import { setConvStreams } from '@laigu/utils/clipboard';

import { StreamsSettingContext } from './components/context';
import useImageViewer from './components/use-image-viewer';
import ImageViewer from './components/image-viewer';
import StreamItem from './components/stream-item';
import { getAllStreams } from './components/selector';

import style from './index.less';

const empty = {};
const LoadBeforeMore = props => {
  const { handleLoadMore, conv } = props;
  if (conv && conv.id) {
    return (
      <div className={style['load-before-more']}>
        {conv.waiting ? (
          <div className={style.box}>
            <span>{'上一条对话加载中'}</span>
            <LoadingOutlined />
          </div>
        ) : (
          <div className={style.box} onClick={() => handleLoadMore(conv.id)}>
            <span>{'查看上一条对话'}</span>
            <CaretUpOutlined />
          </div>
        )}
      </div>
    );
  }
  return null;
};
const LoadAfterMore = props => {
  const { handleLoadMore, conv } = props;
  if (conv && conv.id) {
    return (
      <div className={style['load-after-more']}>
        {conv.waiting ? (
          <div className={style.box}>
            <span>{'下一条对话加载中'}</span>
            <LoadingOutlined />
          </div>
        ) : (
          <div className={style.box} onClick={() => handleLoadMore(conv.id)}>
            <span>{'查看下一条对话'}</span>
            <CaretUpOutlined className={style.after_icon} />
          </div>
        )}
      </div>
    );
  }
  return null;
};

/*
 * 20220425
 * 由于需要考虑到消息高亮
 * 需要将高亮消息的消息id传入
 */
const WorkCenter = React.memo(
  forwardRef((props, ref) => {
    // 高亮消息
    const [highlightMsg, setHighlightMsg] = useState({});
    // 请求过的convId
    const [reqConvId, setReqConvId] = useState({});
    const [scrollEnd, setScrollEnd] = useState(true);

    const [scrollTop, setScrollTop] = useState(true);

    const location = useLocation();
    const {
      data,
      handleAddClue,
      loadStreams,
      handleWithdrawMessage,
      handleTranslateMessage,
      handleRemindMessage,
      createConvSummary,
      updateConvSummary,
      handleConvTag,
      handleReEdit,
      handleSpeechToTxt,
      handleGptSummary,
      handleIntelligentRecommend
    } = props;

    const timelineRef = useRef(null);

    const streamRef = useRef(null);

    const {
      scrollFlag,
      convCreateOn,
      msgWithdraw = empty,
      openClueEnable,
      trackId,
      agentListAll,
      summaryEditable = true,
      convTagEditable = true,
      summaryAddable = true,
      loadMoreAble = true,
      containerId,
      translateEnabled,
      translateLanguage,
      queryTranslateQuota,
      trusted,
      convBelongToMe,
      convListData,
      robotHightMsg = [],
      ended = false,
      listType = '',
      source = ''
    } = data;
    const productCardFunc = useFunction('product_card');
    const clueCollection = useFunction('clue_collection') && openClueEnable;

    const streams = getAllStreams(convListData);
    const { imageViewerData, handleImageStream } = useImageViewer({ streams });

    const [streamsList, setStreamsList] = useState([]);

    const handleLoadMore = id => {
      if (reqConvId && !reqConvId[id]) {
        setReqConvId(reqConvId => ({ ...reqConvId, [id]: true }));
        loadStreams(id)
          .then(() => {
            setReqConvId(reqConvId => ({ ...reqConvId, [id]: false }));
          })
          .catch(() => {
            setReqConvId(reqConvId => ({ ...reqConvId, [id]: false }));
          });
      }
    };

    useEffect(() => {
      if (trackId) {
        setReqConvId({});
        setHighlightMsg({});
        setScrollEnd(true);
      }
    }, [trackId]);

    // * 初始化进入界面 需要判断是什么方式进入 直接会话界面 历史界面
    // * 当前页面在最上面
    // * 需要判断是否有消息高亮显示
    useEffect(() => {
      if (location.pathname !== '/chat') {
        if (robotHightMsg.length) {
          scrollToStream(robotHightMsg[0]);
          return;
        }
        if (scrollTop) {
          streamRef.current.scrollToTop();
        }

        return;
      }
      if (scrollEnd) {
        scrollToEnd();
      }
    }, [convListData]);

    useEffect(() => {
      if (scrollFlag) {
        scrollToEnd();
      }
    }, [scrollFlag]);

    const handleHighLight = useCallback(id => {
      setHighlightMsg(data => {
        if (data[id]) {
          return {
            ...data,
            [id]: data[id] + 1
          };
        }
        return {
          ...data,
          [id]: 1
        };
      });
    }, []);

    const handleClickRemindMessage = useCallback(
      id => {
        scrollToStream(id);
        handleHighLight(id);
      },
      [streamsList]
    );

    const funcProps = {
      handleConvTag,
      createConvSummary,
      updateConvSummary,
      handleReEdit,
      handleAddClue,
      handleImageStream,
      handleWithdrawMessage,
      handleRemindMessage,
      handleTranslateMessage,
      handleClickRemindMessage,
      handleSpeechToTxt,
      handleGptSummary,
      handleIntelligentRecommend
    };

    const streamSetting = useMemo(
      () => ({
        msgWithdraw
      }),
      [msgWithdraw]
    );

    /*
     * 由于最后一条消息使用了padding-bottom会导致 页面滚动最下面时 出现弹动的效果 所以需要记录最后一条消息
     */
    useEffect(() => {
      const list = convListData.reduce((pre, cur, index) => {
        return pre.concat(
          cur.streams.map((stream, ind) => {
            if (index !== 0 && ind === 0) {
              stream.showDol = true;
            }

            if (index === convListData.length - 1 && ind === cur.streams.length - 1) {
              stream.isLastStream = true;
            }
            // 补充 source 信息
            stream.source = source;

            return stream;
          })
        );
      }, []);
      setConvStreams(list);
      setStreamsList(list);
    }, [convListData, trackId]);

    const scrollToStream = useCallback(
      id => {
        const index = streamsList.findIndex(stream => stream.id === id);

        if (index !== -1) {
          streamRef.current.scrollToItem(index);
        }
      },
      [streamsList, containerId]
    );

    /*
     * 存在多次会话时
     */

    const { after_conv, before_conv, hasLoadAfter, hasLoadBefore, centerConvs } = useMemo(() => {
      const convAfter = convListData[convListData.length - 1] ?? {};
      const convBefore = convListData[0] ?? {};

      const { after_conv = {}, hasLoadAfter = false } = convAfter;
      const { before_conv = {}, hasLoadBefore = false } = convBefore;

      const centerConvs = convListData.reduce((pre, cur) => {
        const convId = cur.convId;

        if (convId) {
          pre[convId] = cur.centerConv;
        }

        return pre;
      }, {});

      return {
        after_conv,
        before_conv,
        hasLoadAfter,
        hasLoadBefore,
        centerConvs
      };
    }, [convListData, trackId]);

    /*
     * 加载上一条对话
     *  1. 当前的对话是当前显示的最后一条 index 最小
     *  2. loadMoreAble
     *  3. hasLoadBefore
     * 加载下一条对话
     *  1. 当前的对话是当前显示的第一条 index 最大
     *  2. loadMoreAble
     *  3. hasLoadAfter
     */
    const renderConv = useMemo(() => {
      const data = {
        streams: streamsList,
        centerConvs: centerConvs,
        msgWithdraw,
        productCardFunc,
        convCreateOn,
        clueCollection,
        agentListAll,
        summaryAddable,
        summaryEditable,
        convTagEditable,
        highlightMsg,
        translateEnabled,
        translateLanguage,
        queryTranslateQuota,
        trusted,
        convBelongToMe,
        robotHightMsg,
        ended,
        listType,
        source
      };

      const itemProps = {
        data,
        ...funcProps
      };

      return (
        <StreamItem
          {...itemProps}
          ref={streamRef}
          handleEnd={isEnd => {
            setScrollEnd(isEnd);
          }}
          handleTop={isTop => {
            setScrollTop(isTop);
          }}
          loadMoreBeforeCom={
            loadMoreAble && hasLoadBefore ? <LoadBeforeMore conv={before_conv} handleLoadMore={handleLoadMore} /> : null
          }
          loadMoreAfterCom={
            loadMoreAble && hasLoadAfter ? <LoadAfterMore conv={after_conv} handleLoadMore={handleLoadMore} /> : null
          }
          containerId={containerId}
        />
      );
    }, [
      streamsList,
      after_conv,
      before_conv,
      hasLoadAfter,
      hasLoadBefore,
      centerConvs,
      convListData,
      trackId,
      containerId,
      translateEnabled,
      translateLanguage,
      queryTranslateQuota,
      ended,
      listType
    ]);

    const scrollToEnd = () => {
      streamsList.length && streamRef.current.scrollToBottom();
    };

    /*
     * 向外抛出方法
     * 1. 滚动到最下面
     * 2. 滚动到某一条stream对话
     * 3. 滚动到某一个会话
     * 4. 获取当前会话的所有聊天内容
     * 5. 手动触发重新计算高度
     */
    useImperativeHandle(ref, () => {
      return {
        scrollToBottom: () => scrollToEnd(),
        scrollToItem: id => scrollToStream(id),
        scrollToItemByConvFirstStream: convId => {
          const conv = convListData.find(item => item.convId === convId);

          if (conv) {
            const firstStream = conv?.streams?.[0];

            if (firstStream) {
              scrollToStream(firstStream?.id);
            }
          }
        },
        getAllStreams: () => streamsList,
        resizeDomByHeight: () => {
          streamRef.current && streamRef.current.resizeDomByHeight();
        }
      };
    });

    return (
      <StreamsSettingContext.Provider value={streamSetting}>
        <div className={style.main} ref={timelineRef} id='containerElement'>
          {renderConv}
          {!scrollEnd && (
            <Affix className={style.affix} target={() => timelineRef.current} offsetBottom={0}>
              <div className={style['to-bottom-box']}>
                <div className={style['to-bottom']} onClick={scrollToEnd}>
                  <ArrowDownOutlined />
                  <span>{'回到最后'}</span>
                </div>
              </div>
            </Affix>
          )}
          <ImageViewer {...imageViewerData} />
        </div>
      </StreamsSettingContext.Provider>
    );
  })
);

export default WorkCenter;
